export default () => {
    return ((typeof (window)) !== 'undefined' && window['ontouchstart']) ||
        ((typeof (navigator)) !== 'undefined' && navigator.maxTouchPoints > 0);
}